import { FontFamily, StoreFontFamily } from '@/types';

export const mapFontFamily = (family: FontFamily, index: number): StoreFontFamily => {
  return {
    id: family.id,
    name: family.name,
    fonts: family.fonts.map((font) => ({
      ...font,
      identifier: `sprdfont_${family.id}_${font.id}`,
      familyId: family.id,
      printTypeIds: family.printTypes.map((pt) => pt.id),
      type: 'sprd',
    })),
    printTypeIds: family.printTypes.map((pt) => pt.id),
    index,
    type: 'sprd',
  };
};
